// extracted by mini-css-extract-plugin
export default {"swiperItem":"home_swiperItem__0XUJW","content":"home_content__pu8Ee","swiperSlide":"home_swiperSlide__7xpC4"};